export const UserAvatarModel = Symbol('UserAvatarModel');
